import { IconProps } from '@/types/icon';

export function IconeCompras(props: IconProps) {
  const { size } = props;
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="compras"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={size}
      height={size}
      {...props}
    >
      <path
        d="M14.6667 6.32667H11.4733L8.55332 1.95334C8.42666 1.76667 8.21332 1.67334 7.99999 1.67334C7.78666 1.67334 7.57332 1.76667 7.44666 1.96001L4.52666 6.32667H1.33332C0.966656 6.32667 0.666656 6.62667 0.666656 6.99334C0.666656 7.05334 0.673323 7.11334 0.693323 7.17334L2.38666 13.3533C2.53999 13.9133 3.05332 14.3267 3.66666 14.3267H12.3333C12.9467 14.3267 13.46 13.9133 13.62 13.3533L15.3133 7.17334L15.3333 6.99334C15.3333 6.62667 15.0333 6.32667 14.6667 6.32667ZM7.99999 3.52667L9.86666 6.32667H6.13332L7.99999 3.52667ZM12.3333 12.9933L3.67332 13L2.20666 7.66001H13.8L12.3333 12.9933ZM7.99999 8.99334C7.26666 8.99334 6.66666 9.59334 6.66666 10.3267C6.66666 11.06 7.26666 11.66 7.99999 11.66C8.73332 11.66 9.33332 11.06 9.33332 10.3267C9.33332 9.59334 8.73332 8.99334 7.99999 8.99334Z"
        fill="currentColor"
      />
    </svg>
  );
}
